<template >
  <div :key="'composition-api-computed'">
    <h2>Lifecycle hooks</h2>
    <pre><code class="javascript" data-trim data-noescape data-line-numbers="1-99" v-html="exampleText"></code></pre>
  </div>
</template>

<script>
export default {
  data() {
    return {
      exampleText: `import { onMounted } from 'vue'

export default {
  setup() {
    onMounted(() => {
      console.log('component is mounted!')
    })
  }
}`
    };
  }
};
</script>